function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.28 9.184l6.286-6.287A1.482 1.482 0 0015.47.8L9.184 7.088 2.897.801A1.482 1.482 0 00.8 2.897l6.287 6.287L.801 15.47a1.482 1.482 0 002.096 2.096l6.287-6.287 6.286 6.287a1.482 1.482 0 002.096-2.096L11.28 9.184z",
  fill: "#333",
  fillRule: "evenodd",
  fillOpacity: 0.5
});

function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCancel;